import $http from '@/http';

const state = () => ({
    jobs: null,
    jobsInProgress: null,
    schedulerStatus: 'unknown',
    recentFailures: [],
    jobStats: {
        today: 0,       // Initialize default value
        last7Days: 0,   // Initialize default value
        last30Days: 0,  // Initialize default value
    }
});

const getters = {
    stateJobs: state => state.jobs,
    stateSchedulerStatus: state => state.schedulerStatus,
    stateJobsInProgressCount: state => state.jobsInProgress ? state.jobsInProgress.length : 0,
    stateRecentFailures: state => state.recentFailures,
    stateJobStats: state => state.jobStats,  // Add this getter to ensure jobStats is accessible
};

const actions = {

    async getSchedulerStatus({ commit }) {
        try {
            let { data: status } = await $http.get('admin/scheduler_status');
            commit('setSchedulerStatus', status);
        } catch (e) {
            console.error(e);
        }
    },

    async getJobs({ commit }) {
        try {
            let { data: jobs } = await $http.get('jobs');
            commit('setJobs', jobs);
        } catch (e) {
            console.error(e);
        }
    },

    async getTasks(_, job_id) {
        let {data: tasks} = await $http.get(`tasks?parent_job_id=${job_id}`);
        for (let i in tasks) {
            if (typeof tasks[i].failure_details === 'string') {
                tasks[i].failure_details = JSON.parse(tasks[i].failure_details)
            }
        }
        return tasks;
    },

    async getTranscription(_, job_id) {
        let {data: transcript} = await $http.get(`job/${job_id}/transcript`);
        return transcript;
    },

    async getJob({dispatch}, job_id) {
        let {data: job} = await $http.get(`job/${job_id}`);
        if (typeof job.Workflow === 'string') {
            job.Workflow = JSON.parse(job.Workflow)
        }
        if (typeof job.Data === 'string') {
            job.Data = JSON.parse(job.Data)
        }
        if (typeof job.Failure_Details === 'string') {
            job.Failure_Details = JSON.parse(job.Failure_Details)
        }

        job.Tasks = await dispatch('getTasks', job_id);

        if (job.Status === 'completed') {
            let transcript = await dispatch('getTranscription', job_id);
            job.Text = transcript.content.text;
        }
        return job;
    },

    async getJobsInProgress({ commit }) {
        try {
            let { data: jobsInProgress } = await $http.get('jobs?status=in_progress');
            commit('setJobsInProgress', jobsInProgress);
        } catch (e) {
            console.error(e);
        }
    },

    async getRecentFailures({ commit }) {
        try {
            let { data: failedJobs } = await $http.get('jobs?status=failed');
            // Sort by the failure date and limit to the 5 most recent
            const recentFailures = failedJobs
                .sort((a, b) => new Date(b.Failure_Details.time) - new Date(a.Failure_Details.time))
                .slice(0, 5);
            commit('setRecentFailures', recentFailures);
            return recentFailures;
        } catch (e) {
            console.error(e);
        }
    },

    async getJobCompletionStats({ commit }) {
        try {
            let { data: completedJobs } = await $http.get('jobs?status=completed');
            const now = new Date();

            // Helper function to check if a date falls within a period
            const isWithinDays = (date, days) => {
                const jobDate = new Date(date);
                const daysAgo = new Date(now);
                daysAgo.setDate(now.getDate() - days);
                return jobDate >= daysAgo && jobDate <= now;
            };

            // Compute stats based on completion time
            const todayCount = completedJobs.filter(job => isWithinDays(job.completion_time, 1)).length;
            const last7DaysCount = completedJobs.filter(job => isWithinDays(job.completion_time, 7)).length;
            const last30DaysCount = completedJobs.filter(job => isWithinDays(job.completion_time, 30)).length;

            const stats = {
                today: todayCount,
                last7Days: last7DaysCount,
                last30Days: last30DaysCount,
            };

            commit('setJobCompletionStats', stats);
            return stats;
        } catch (e) {
            console.error(e);
        }
    },
};

const mutations = {
    setJobs(state, jobs) {
        state.jobs = jobs;
    },
    setSchedulerStatus(state, status) {
        state.schedulerStatus = status;
    },
    setJobsInProgress(state, jobsInProgress) {
        state.jobsInProgress = jobsInProgress;
    },
    setRecentFailures(state, recentFailures) {
        state.recentFailures = recentFailures;
    },
    setJobCompletionStats(state, stats) {
        state.jobStats = stats;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
